import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {TransactionOutlined} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";

export abstract class APromotion extends ABusiness {
    icon = () => h(TransactionOutlined, {style: 'color: #ef4444'});
    title = '促销';
    description = '';

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    implementations(status: EActivityStatus): RadioGroupChildOption[] {
        return {
            active: [{value: 'tier_group', label: '阶梯团'}],
            preheating: [{value: 'deposit', label: '抢占'}],
            finished: []
        }[status]
    }
}